'use strict';

const Translator = require('./../../../core/translator');
const PopinManager = require('./../../../services/popin');
const Loader = require('./../../../services/loader');

module.exports.onRequestFail = function(data) {
    let {request} = data;

    if ((request.getUrl().toLocaleLowerCase().indexOf('ads')) !== -1) {
        let popin = PopinManager.createPopin({
            'title': Translator.translate('adblock_detect_title'),
            'height': 200,
            'width': 500,
            'buttons': [
                {
                    class: 'popin popin-ok',
                    text: Translator.translate('submit'),
                    click: function() {
                        popin.hide();
                    },
                },
            ],
        });
        popin.setContent(Translator.translate('adblock_detect_description'));
        popin.display();
    }

    Loader.stop();
};


